// FILE: src/Components/Unsubscribe.js (NEW FILE)

import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios'; // Use a plain axios instance for public routes
import { Spin } from 'antd';
import HeadLogo from "../Assets/Oolook_logo.png";

export default function Unsubscribe() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Processing your unsubscribe request...');

  useEffect(() => {
    const performUnsubscribe = async () => {
      const email = searchParams.get('email');
      if (!email) {
        setMessage('Invalid unsubscribe link. Redirecting...');
        setTimeout(() => navigate('/unsubscribe-error'), 2000);
        return;
      }

      try {
        // This public API call doesn't need the auth token
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/user/unsubscribe`, {
          params: { email }
        });
        
        // The backend controls the redirect, but we can handle the final page display here.
        // In this setup, we will be redirected by the backend. If that fails, we navigate.
        window.location.href = response.data.redirectTo; // The backend will send a redirect URL. Let's assume it does.

      } catch (error) {
        // If the backend call fails, we manually navigate to the error page.
        console.error("Unsubscribe API call failed:", error);
        navigate('/unsubscribe-error');
      }
    };

    performUnsubscribe();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-neutral-light">
      <div className="auth-card text-center">
        <img src={HeadLogo} alt="Oolook Logo" className="mx-auto h-12 w-auto mb-6" />
        <Spin size="large" />
        <p className="text-center text-lg text-neutral-muted mt-4">
          {message}
        </p>
      </div>
    </div>
  );
}